module.exports = __webpack_public_path__ + "static/media/discussion-icon.0af1d80e.svg";